/**
 * interpolates a data series at given x respecting interpolation
 * returns interpolated y of x, as well as previous and next datapoint
 */
export const interpolate = (data, x, interpolation) => {
  if (!data) return null;
  let yValue;
  const [prev, next] = data.reduce((acc, curr) => ([
    curr.x <= x && (!acc[0] || curr.x >= acc[0].x) ? curr : acc[0],
    curr.x >= x && (!acc[1] || curr.x <= acc[1].x) ? curr : acc[1],
  ]), [null, null]);
  if (prev && next) {
    if (interpolation === 'linear') {
      const slope = (next.y - prev.y) / (next.x - prev.x);
      yValue = prev.y + slope * (x - prev.x);
    }
    if (interpolation === 'step') {
      yValue = prev.y;
    }
  } else if (prev) {
    yValue = prev.y;
  }
  return {
    x,
    y: yValue,
    prev,
    next,
  };
};
